import localStorage from 'r/utils/localStorage';
import {ANALYTICS_ID as localStorageKey} from './KEYS';

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

if (!localStorage.getItem(localStorageKey)) {
  localStorage.setItem(localStorageKey, uuidv4());
}

export default class StoredAnalyticsId {
  static get() {
    return localStorage.getItem(localStorageKey);
  }
}
